import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';

export default class AutocompleteTableResult extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    formName: PropTypes.string.isRequired,
    roles: PropTypes.string,
    company_name: PropTypes.string,
    onDelete: PropTypes.func,
  }

  static defaultProps = {
    email: 'N/A',
    company_name: 'N/A',
    onDelete: null
  }

  render() {
    return (
      <tr key={`row-${this.props.id}`}>
        <td className="u-align-middle">
          { this.props.index }
        </td>
        <td className="u-align-middle">
          <div className="u-flex u-items-center">
            <Avatar
              src={this.props.avatar}
              name={this.props.name}
              className="u-h-6 u-w-6 u-mr-2 u-flex-shrink-0"
            />
            <span>{ this.props.name }</span>
          </div>
        </td>
        <td className="u-align-middle">
          {this.props.company_name &&
            <div className="u-flex u-items-center">
              <Avatar
                name={this.props.company_name}
                type="company"
                className="u-h-6 u-w-6 u-mr-2 u-flex-shrink-0"
              />
              <span>{this.props.company_name}</span>
            </div>
          }
        </td>
        <td className="u-align-middle">
          { this.props.roles }
        </td>
        <td className="u-align-middle">
          <a onClick={this.props.onDelete} className="Button Button--red">
            <i className="Icon Icon-delete u-mr-2" />
            Remove attendee
          </a>
          { this.props.formName && <input type="hidden" name={this.props.formName} value={this.props.id} /> }
        </td>
      </tr>
    );
  }
}
